import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function usePagesThisWeek() {
  return useQuery({
    queryKey: ['profile', 'pages-this-week'],
    queryFn: () => libraryApi.getPagesThisWeek(),
    staleTime: 5 * 60 * 1000,
  });
}
